import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { API, L } from '../shared';

const why = (r, lang) => {
  if (!r.has_email) return [L(lang, 'Χωρίς email — δεν θα σταλεί', 'No email — will be skipped'), 'text-red-600'];
  if (r.pending_invitation) return [L(lang, 'Υπάρχει ήδη ενεργή πρόσκληση — χρησιμοποιήστε επαναποστολή', 'Active invitation exists — use resend'), 'text-amber-700'];
  return [L(lang, 'Θα σταλεί', 'Will be sent'), 'text-emerald-700'];
};

export const SendConfirmDialog = ({ draft, onClose, onDone, lang }) => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  useEffect(() => {
    if (!draft) return;
    setRows(null); setResult(null);
    axios.get(`${API}/owner-feedback/drafts/${draft.draft_id}/recipients`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [draft]);
  const ok = (rows || []).filter((r) => r.has_email && !r.pending_invitation).length;
  const send = async () => {
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/owner-feedback/drafts/${draft.draft_id}/send`, { confirm: true })).data;
      setResult(r);
      const failed = r.results.filter((x) => String(x.email_status || '').startsWith('failed')).length;
      if (failed) toast.error(L(lang, `${failed} αποτυχίες αποστολής`, `${failed} delivery failures`)); else toast.success(L(lang, `Στάλθηκαν ${r.invited}`, `Sent ${r.invited}`));
      onDone && onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Error'); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!draft} onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="inv-send-dialog">
        <DialogHeader><DialogTitle>{L(lang, 'Επιβεβαίωση παραληπτών', 'Confirm recipients')}</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500">{draft?.building_name} · {draft?.title || L(lang, '(χωρίς τίτλο)', '(untitled)')}</p>
        <div className="border border-zinc-200 divide-y divide-zinc-100 text-xs">
          {(rows || []).map((r) => {
            const res = result?.results.find((x) => x.apartment_id === r.apartment_id);
            const [msg, cls] = res ? [res.result === 'invited' ? `${L(lang, 'Στάλθηκε', 'Sent')} · ${res.email_status}` : res.reason, res.result === 'invited' && !String(res.email_status).startsWith('failed') ? 'text-emerald-700' : 'text-red-600'] : why(r, lang);
            return <div key={r.apartment_id} className="flex gap-2 px-2 py-1.5" data-testid={`inv-send-row-${r.apartment_id}`}><span className="font-mono w-10">{r.apartment_number}</span><span className="flex-1 truncate">{r.owner_name} <span className="text-zinc-400">{r.email}</span></span><span className={cls}>{msg}</span></div>;
          })}
          {rows === null && <div className="p-4 text-center text-zinc-400">…</div>}
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-none" onClick={onClose} data-testid="inv-send-close">{result ? L(lang, 'Κλείσιμο', 'Close') : L(lang, 'Άκυρο', 'Cancel')}</Button>
          {!result && <Button className="rounded-none bg-zinc-900" disabled={busy || !ok} onClick={send} data-testid="inv-send-confirm">{L(lang, `Αποστολή σε ${ok}`, `Send to ${ok}`)}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
